<template>
	<div :class="['static-field', ...variantClassList]">
		<span class="static-field__label">
			<slot name="label">
				{{ labelValue }}
			</slot>
		</span>
		<span class="static-field__value">
			<slot name="value">
				{{ value }}
			</slot>
		</span>
	</div>
</template>

<script>
import componentVariantMixin from '@/mixins/component-variant-mixin';
import variantClasses from './variant-classes/static-field-variant-classes';

/**
 * StaticField
 * @param {('leftLabel')} variant - the static-field visual variation
 */
export default {
	name: 'StaticField',
	created() {
		this.variantClasses = variantClasses;
	},
	mixins: [componentVariantMixin],
	props: {
		label: {
			type: String,
			default: ''
		},
		value: {
			type: String,
			default: ''
		}
	},
	// DEV NOTE: make sure the label for version leftLabel includes the : at the end and non for default version. This was made for testing purpose only. Need same logic for slots
	computed: {
		labelValue() {
			let labelArray = this.label.split('');

			if (labelArray[labelArray.length - 1] === ':') {
				if (this.variant === 'leftLabel') {
					return this.label;
				} else {
					return this.label.slice(0, -1);
				}
			} else {
				if (this.variant === 'leftLabel') {
					return `${this.label}:`;
				} else {
					return this.label;
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.static-field {
	display: inline-flex;
	flex-direction: column;
	color: var(--field-fg);
	font-size: $field-font-size;

	&__label {
		font-size: inherit;
		font-weight: $bold-font-weight;
		margin-bottom: $gutter-sm;
		text-transform: capitalize;
	}

	&--left-label {
		flex-direction: row;
		align-items: last baseline; /*Added to align text and icon while using the leading/trailing label slot.*/

		.static-field__label {
			margin-bottom: 0;
			margin-right: $gutter-sm;
		}
	}
}
</style>
